import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation } from 'react-apollo';

import {
  Input,
  Button,
} from 'reactstrap';
import moment from 'moment';
import { GET_CHAT_ROOM, GET_ADMIN_INFO } from '../../../graphql-client/queries';
import { SEND_OFFER_CHAT_MOTIFICATION } from '../../../graphql-client/mutations';

import {
  EMPTY_MESSAGE_ICON_FE, CHAT_MESSAGE_TYPE, getMediaRenderTag, CHAT_CONSTANTS, isSameDay, dateFormats,
}
  from '../../../utils';
import { myFirestore, fieldPath } from '../../../config/firebase';
import ChatMessages from './ChatMessages';
import SendMedia from '../../admin/offer/detail/SendMedia';
import {
  mapChatData, sendMessage,
} from '../../../utils/chatUtils';
import { useChatMessageInitializer } from '../../../utils/chatMessageInitializer';

const noChatMessage = (messageLoading) => (

  <div className="message-detail-window empty-window">
    { !messageLoading && (
      <div className="empty-box">
        <img
          src={EMPTY_MESSAGE_ICON_FE}
          all="Message"
          alt="message"
        />
        <h2>No messages yet</h2>
        <p>You have no messages yet. Once you start, your conversations will appear here.</p>
      </div>
    )}
  </div>
);
function MessageDetail(props) {
  const { getMessages, markConversationAsRead } = useChatMessageInitializer();
  const chatWindowRef = useRef();
  const {
    offerDetail, detailOpen, detailHide, artistId, openOfferDetail, toggleChatModal,
  } = props;
  const [chatMedia, setChatMedia] = useState([]);
  const [chatRoomId, setChatRoomId] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [mediaUrls, setMediaURLs] = useState([]);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [uploadingMessage, setUploadingMessage] = useState(false);
  const [uploadChatMedia, setUploadChatMedia] = useState([]);
  const [chatMessage, setChatMessage] = useState('');
  const [messageLoading, setMessageLoading] = useState(true);

  const { data: chatRoomData } = useQuery(GET_CHAT_ROOM,
    { variables: { offerId: offerDetail._id, participants: [artistId] }, skip: !offerDetail });

  const { data: adminInfoData } = useQuery(GET_ADMIN_INFO);

  const [sendOfferChatNotification] = useMutation(SEND_OFFER_CHAT_MOTIFICATION, {
    variables: {},
  });
  const getChatMessages = async () => {
    const messages = await getMessages(chatRoomData.getChatRoom, artistId);
    props.setMessageLoading(false);
    setChatMessages(mapChatData({ _id: artistId }, messages));
  };

  const onNewMessage = () => myFirestore
    .collection(`${CHAT_CONSTANTS.MESSAGE_BOARD}`).where(fieldPath.documentId(), 'in', chatRoomData.getChatRoom.map((el) => el._id))
    .onSnapshot((docs) => {
      setChatMessages(mapChatData({ _id: artistId }, docs));
      markConversationAsRead(chatRoomData.getChatRoom, artistId);
      props.setMessageLoading(false);
      setMessageLoading(false);
    });

  useEffect(() => {
    props.setMessageLoading(true);
  }, []);

  useEffect(() => {
    let newMessageSub = () => { };
    if (chatRoomData && chatRoomData.getChatRoom.length > 0) {
      setChatRoomId(chatRoomData.getChatRoom[0]._id);
      newMessageSub = onNewMessage();
      setChatMessage('');
      setChatMedia([]);
    }
    return () => {
      newMessageSub();
    };
  }, [chatRoomData]);

  const scrollToBottom = () => {
    chatWindowRef && chatWindowRef.current && chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
  };

  useEffect(() => {
    chatMessages.length > 0 && scrollToBottom();
  }, [chatMessages]);

  const uploadMedia = ((e) => {
    const file = e.target.files[0];
    const image = getMediaRenderTag(file);
    const now = Date.now();
    setChatMedia([...chatMedia, {
      id: now, image, file, type: file.type,
    }]);
  });

  const sendChatMessage = async (message) => {
    setSendingMessage(true);
    await sendMessage(artistId,
      adminInfoData.adminInfo.data._id,
      message, chatRoomData.getChatRoom, offerDetail._id);
    setSendingMessage(false);
    getChatMessages();
    adminInfoData && sendOfferChatNotification({
      variables:
        { offerId: offerDetail._id, receiverId: adminInfoData.adminInfo.data._id },
    });
  };

  const handleSendMessages = async (message) => {
    if (chatMedia.length === 0) {
      if (message) {
        sendChatMessage([{ message, type: CHAT_MESSAGE_TYPE.TEXT }]);
        setChatMedia([]);
        setChatMessage(null);
      }
      return;
    }
    setUploadingMessage(true);
    let upChatMedia = chatMedia;
    if (message) {
      upChatMedia = [...upChatMedia, { message, type: CHAT_MESSAGE_TYPE.TEXT }];
    }
    setUploadChatMedia(upChatMedia);
    setChatMedia([]);
    setChatMessage(null);
    scrollToBottom();
  };

  const mediaUploadCompleteHandler = (id, url, file) => {
    mediaUrls.push({
      id,
      message: url,
      type: file.type,
      size: file.size,
      name: file.name,
    });
    const filterMedia = uploadChatMedia.filter((el) => mediaUrls.findIndex((dl) => dl.id === el.id) === -1);

    setMediaURLs(mediaUrls);
    if (filterMedia.length === 0 || (filterMedia.length === 1 && filterMedia[0].type === 'text')) {
      const sendMesg = filterMedia[0] && filterMedia[0].message ? [...mediaUrls, filterMedia[0]] : mediaUrls;
      sendChatMessage(sendMesg);
      setUploadChatMedia([]);
      setChatMessage(null);
      setMediaURLs([]);
    }
  };

  const onKeyPressHandler = (event) => {
    if (event.key === 'Enter') {
      !sendingMessage && handleSendMessages(event.target.value);
    }
  };
  const onChangeHandler = (event) => {
    setChatMessage(event.target.value);
  };

  const renderMediaSendings = (media) => media && media.map((el) => (
    <div className="admin-message-dashboard-row" key={el.id || Math.random()}>
      <div className="admin-message-dashboard-text send">
        <SendMedia data={el} mediaUploadComplete={mediaUploadCompleteHandler} scrollToBottom={scrollToBottom} />
      </div>
    </div>
  ));

  return (
    <div className={`modal-message-detail ${detailOpen ? 'show' : 'hide'}`}>
      <div className="message-detail">
        <div
          className="message-detail-head"
        >
          <div
            className="icon icon-next rotate-180"
            onClick={detailHide}
          />
          <h3
            className="cursor-pointer"
            onClick={() => {
              toggleChatModal();
              openOfferDetail && openOfferDetail(offerDetail._id);
            }}
          >
            {offerDetail.clientName}
          </h3>
          <p>
            {offerDetail.title}
            {' '}
            |
            {' '}
            {moment(offerDetail.offerMinDate).format(dateFormats.DATE_WITHOUT_YEAR)}
            -
            {moment(offerDetail.offerMaxDate).format(dateFormats.DATE_WITHOUT_YEAR)}
            {' '}
          </p>
        </div>
        {chatMessages.length <= 0
          ? noChatMessage(messageLoading)
          : (
            <div className="message-detail-window" ref={chatWindowRef}>
              { chatMessages && chatMessages.map((el) => (
                <div key={el.date} className="send-media-row">
                  <div className="admin-message-dashboard-date">
                    <h4>{isSameDay(el.date, new Date()) ? 'Today' : el.date}</h4>
                  </div>
                  <ChatMessages messages={el.messages} />
                </div>
              ))}
              {uploadingMessage && renderMediaSendings(uploadChatMedia)}
            </div>
          )}
        <div className="admin-message-input">
          <div className="media-thumb-box">
            {!sendingMessage && chatMedia && chatMedia.map((el) => (
              <div className="thumb-box" key={el.id}>
                {el.type !== 'text' && (
                  <img
                    className="image-cover"
                    src={el.image}
                    alt="media"
                  />
                )}
                <button
                  type="button"
                  className="icon icon-cross"
                  onClick={() => {
                    setChatMedia(chatMedia.filter((cm) => cm.id !== el.id));
                  }}
                />
              </div>
            ))}
          </div>
          <div className="message-detail-input-box">
            <Input
              type="text"
              placeholder="Write your message here"
              value={chatMessage || ''}
              onChange={onChangeHandler}
              onKeyPress={onKeyPressHandler}
            />

            <Button
              type="button"
              disabled={(!chatMessage && !chatMedia) || !chatRoomId}
              className="icon-send"
              onClick={() => handleSendMessages(chatMessage)}
            />
            <label htmlFor="mediaFile" className="icon-link">
              <input className="icon-send" id="mediaFile" type="file" onChange={uploadMedia} />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

MessageDetail.propTypes = {
  offerDetail: PropTypes.shape({
    _id: PropTypes.string,
    clientName: PropTypes.string,
    title: PropTypes.string,
    offerMaxDate: PropTypes.string,
    offerMinDate: PropTypes.string,
  }),
  detailOpen: PropTypes.bool.isRequired,
  detailHide: PropTypes.func.isRequired,
  artistId: PropTypes.string.isRequired,
  openOfferDetail: PropTypes.func,
  toggleChatModal: PropTypes.func.isRequired,
  setMessageLoading: PropTypes.func.isRequired,
};
MessageDetail.defaultProps = {
  offerDetail: null,
  openOfferDetail: null,
};

export default React.memo(MessageDetail);
